var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.9 21.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,0.6l-0.1-0.1c-0.6-0.6-1.6-0.6-2.2,0L11,8.6L2.8,0.5c-0.6-0.6-1.6-0.6-2.2,0 L0.5,0.6c-0.6,0.6-0.6,1.6,0,2.2L8.6,11l-8.2,8.2c-0.6,0.6-0.6,1.6,0,2.2l0.1,0.1c0.6,0.6,1.6,0.6,2.2,0l8.2-8.2l8.2,8.2 c0.6,0.6,1.6,0.6,2.2,0l0.1-0.1c0.6-0.6,0.6-1.6,0-2.2L13.3,11l8.2-8.2C22.1,2.2,22.1,1.2,21.5,0.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8dbab32ba22e80def7cd6798c0b4bcd4.svg";
export { ForwardRef as ReactComponent };